/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddressTriggerWorkflow } from '../../models/address-trigger-workflow';
import { AddressTriggerWorkflowCreateRequest } from '../../models/address-trigger-workflow-create-request';

export interface CreateAddressTriggerWorkflow$Params {
      body: AddressTriggerWorkflowCreateRequest
}

export function createAddressTriggerWorkflow(http: HttpClient, rootUrl: string, params: CreateAddressTriggerWorkflow$Params, context?: HttpContext): Observable<StrictHttpResponse<AddressTriggerWorkflow>> {
  const rb = new RequestBuilder(rootUrl, createAddressTriggerWorkflow.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AddressTriggerWorkflow>;
    })
  );
}

createAddressTriggerWorkflow.PATH = '/api/v1/workflows/address-trigger-workflows';
